<template>
  <div>
    <div class="section-header">{{ getSectionName(sectionName) }}</div>
    <div v-for="(data, key) in sectionData" :key="key" class="row mb-1 settings-group">
      <div class="col-1"></div>
      <div class="font-weight-bolder text-left" :class="data.type == 'checkbox' ? 'col-8' : 'col-5'">
        <div class="hover-container">
          <label :for="data.field" class="hover-text">{{ data.displayValue }}</label>
          <span class="hover-field">{{ data.field }}</span>
        </div>
      </div>
      <div :class="data.type == 'checkbox' ? 'col-3' : 'col-5'">
        <div v-if="data.type === 'text'">
          <div v-if="!editState[data.field]" class="section-column-data">
            {{ getFieldValue(company, sectionName, data.field) }}
            <i v-if="!isPaymentIntegration(sectionName) && data.editable !== false" 
              class="las la-edit la-lg edit-button"
              @click="toggleEditState(data.field)">
            </i>
          </div>
          <div v-else-if="company && data.editable !== false">
            <b-form-input v-if="!isPaymentIntegration(sectionName)" v-model="company[data.field]" :id="data.field" />
            <b-form-input v-else v-model="company.payment_integration[data.field]" :id="data.field" />
            <div class="mt-2">
              <i class="las la-times cancel-button" @click="cancelEditState(sectionName, data.field)"></i>
              <i class="las la-check save-details-button" @click="saveBusinessField(data.field)"></i>
            </div>
          </div>
        </div>
        <div v-else-if="company">
          <b-form-checkbox 
            v-if="!isPaymentIntegration(sectionName)" 
            v-model="company[data.field]" 
            :disabled=disabled 
            :id="data.field"
            switch
          >
          </b-form-checkbox>
          <b-form-checkbox 
            v-else 
            v-model="company.payment_integration[data.field]" 
            :disabled=true
            :id="data.field"
            switch 
          >
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'settings-section',
  props: {
    company: {
      type: Object,
      default() {
        return {};
      },
    },
    sectionData: {
      type: Object,
      default() {
        return {};
      },
    },
    sectionName: {
      type: String,
      default() {
        return {};
      },
    },
    editState: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      originalCompanyObj: null,
      disabled: false,
    };
  },
  methods: {
    isPaymentIntegration(sectionName) {
      return sectionName === "Payment_Integration";
    },
    getSectionName(sectionName) {
      if (!sectionName) return "";
      return sectionName.split('_').join(' ');
    },
    getFieldValue(company, sectionName, field) {
      if (!company) return '-';
      const getValue = (obj, field) => obj && obj[field] !== undefined ? obj[field] : '-';
      const value = this.isPaymentIntegration(sectionName)
        ? getValue(company.payment_integration, field)
        : getValue(company, field);

      return Array.isArray(value) ? value.join(', ') : value;
    },
    resetBusinessField(sectionName, field) {
      if (this.isPaymentIntegration(sectionName)) {
        this.company.payment_integration[field] = this.originalCompanyObj.payment_integration[field];
      } else {
        this.company[field] = this.originalCompanyObj[field];
      }
    },
    toggleEditState(field) {
      if (this.disabled === true) return;
      const fieldData = Object.values(this.sectionData).find((d) => d.field === field);
      if (fieldData && fieldData.editable === false) return;
      this.$set(this.editState, field, !this.editState[field]);
    },
    cancelEditState(sectionName, field) {
      this.resetBusinessField(sectionName, field);
      this.toggleEditState(field);
    },
    saveBusinessField(field) {
      this.toggleEditState(field);
    },
  },
  watch: {
    company(data) {
      this.originalCompanyObj = JSON.parse(JSON.stringify(data));
    },
  },
};
</script>

<style scoped lang="scss">
@import "../CompanySettings.scss";
</style>